/* eslint-disable max-len */
/* eslint-disable max-lines */
// import assert from 'assert';
import jsCookie from 'js-cookie';
import ServerBase from './server_base';
import {
    DocumentOperateType,
    WizDocumentCreateDoc,
    DocumentUpdateData,
    WizRequestOptions,
    DocMembers,
    LikeData,
    CoinData,
    IpageInfo,
    IPageSecurityGetAccessId,
    IPageSecurityParams,
    IPublishStatus,
    GroupInfo,
} from '@/interface';
import * as store from '@/store';
import assert from 'assert';
import {ServerConfig} from '@/config/routers';
import {DOC_TYPE} from '@/constants/document/doc';
import {getDocUrl, getDstToken, throttleAsync} from './utils';
import {accountServerObj} from './account_server';

const isDevProxy = process.env.REACT_APP_IS_PROXY === 'true';
const appId = (window as any).sdkToken || '';

class KnowledgeServer extends ServerBase {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    serverUrl: string;
    user: User;
    wikiAccessToken: string;
    mockBaseUrl: string;

    constructor(
        user: User,
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        accessToken: string
    ) {
        super('wikiAccessToken');
        this.user = user;
        this.spaceGuid = spaceGuid;
        this.groupGuid = groupGuid;
        this.repositoryGuid = repositoryGuid;
        this.wikiAccessToken = accessToken;
        // server下发的携带了协议内容
        // 理想情况下 server不应下发协议部分内容
        // 但为了避免前端代码与后端代码版本不一致 导致问题 暂时先由前端兼容
        // 等版本覆盖完全后 再由server修改
        this.serverUrl = isDevProxy ? `/wiki/ks/${repositoryGuid}` : `${ServerConfig.ks}/${repositoryGuid}`;
        // this.mockBaseUrl = `https://yapi.baidu-int.com/mock/13783/wiki/ks/${repositoryGuid}`;
        this.mockBaseUrl = 'https://yapi.baidu-int.com/mock/13783';
    }

    get token() {
        if ((window as any).isSdkPage) {
            const appId = (window as any).sdkToken || '';
            return `${this.user.token}&${appId}`;
        }
        return this.user.token;
    }

    get requestOptions(): WizRequestOptions {
        if ((window as any).isSdkPage) {
            return {
                wikiAccessToken: `${this.wikiAccessToken}`,
                appId: `${appId}`,
            };
        }
        return {
            wikiAccessToken: this.wikiAccessToken,
        };
    }

    onTokenUpdated(token: string) {
        this.wikiAccessToken = token;
    }

    // ----------------zz---------------
    async getDocuments(parentGuid: string | null, recent?: boolean) {
        //
        const options = this.requestOptions;
        const params: {
            parentGuid: string;
            recent?: boolean;
        } = {
            parentGuid: parentGuid || '',
        };
        if (recent) {
            params.recent = true;
        }
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.serverUrl}/docs`,
                    params,
                },
                options
            )
        );
        // console.log('get documents');
        return result as WizDocument[];
    }
    // ----------------新的获取节点列表的接口相比原来少了一些没有必要的数据以此来提高接口速度---------------
    async getDocumentsNew(data: {parentGuid: string | null}) {
        const {parentGuid} = data;
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/docs/dir?repositoryGuid=${this.repositoryGuid}&parentGuid=${parentGuid || ''}`,
                    // url: `${this.serverUrl}/dirDocs`,
                    // params,
                },
                options
            )
        );
        return result as WizDocument[];
    }

    // MARKS:
    async createDocumentDirectory(params: WizDocumentCreateDoc) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/docs/create`,
                    data: params,
                },
                options
            )
        );
        // console.log('create document');
        return result;
    }

    // async createDocument(doc: WizDocument) {
    //     //
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 method: 'post',
    //                 url: `${this.serverUrl}/docs`,
    //                 data: doc,
    //             },
    //             options
    //         )
    //     );
    //     // console.log('create document');
    //     return result;
    // }

    // 创建表格
    async createSheet(doc: WizDocument) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/middleware/${this.repositoryGuid}/files`,
                    params: {
                        parentGuid: doc.parentGuid, // 后端同学要求在query带上parentGuid参数
                    },
                    data: doc,
                    headers: {
                        'x-file-type': 4, // type 1：文档 4：表格
                    },
                },
                options
            )
        );
        return result;
    }

    // 创建演示文稿
    async createPPT(doc: WizDocument) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/ppt/${this.repositoryGuid}/ppt`,
                    params: {
                        parentGuid: doc.parentGuid, // 后端同学要求在query带上parentGuid参数
                    },
                    data: doc,
                },
                options
            )
        );
        return result;
    }

    // 创建数据表夹
    async createDataSheet(doc: WizDocument) {
        const dataSheetToken = await getDstToken();
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/datasheet/folder/create`,
                    data: {
                        ...doc,
                        viewName: '表格',
                    },
                    headers: {
                        'x-datasheet-token': dataSheetToken,
                    },
                },
                options
            )
        );
        return result;
    }

    async getSheetSign(repoGuid: string, docGuid: string) {
        const options = this.requestOptions;
        const query = (window as any).isSdkPage ? `?businessAppId=${(window as any).sdkToken}` : '';
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/middleware/${repoGuid}/docs/${docGuid}/token` + query,
                    headers: {
                        'x-file-type': 4, // type 1：文档 4：表格
                    },
                },
                options
            )
        );
        return result;
    }

    //
    async isLatestDocument(docGuid: string): Promise<boolean> {
        const options = this.requestOptions;
        const latest = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.serverUrl}/docs/${docGuid}/latest`,
                },
                options
            )
        );
        return latest;
    }
    // 获取文档信息（无权限校验）
    async getDocumentInfoAccess(docGuid: string, childGuid: string) {
        // 通过childGuid判断当前人是否有权限获取目录树的节点信息
        if (!childGuid) {
            throw new Error('childGuid 不存在');
        }
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/docs/access?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}&childGuid=${childGuid}`,
                },
                options
            )
        );
        return result as WizDocument;
    }
    // 获取文档信息（有权限校验）
    async getDocumentInfo(docGuid: string) {
        // 对外的接口地址改了
        if (window.isTocPage) {
            const options = this.requestOptions;
            const result = await this.request(
                Object.assign(
                    {
                        method: 'get',
                        url: `${ServerConfig.ks}/external/repository/doc/getDocInfoByDocGuid?docGuid=${docGuid}&repositoryGuid=${this.repositoryGuid}`,
                        returnFullError: true,
                    },
                    options
                )
            );
            return result as WizDocument;
        } else {
            const options = this.requestOptions;
            const result = await this.request(
                Object.assign(
                    {
                        method: 'get',
                        url: `${this.serverUrl}/docs/${docGuid}`,
                        returnFullError: true,
                    },
                    options
                )
            );
            return result as WizDocument;
        }
    }

    updateDocumentOperate(doc: DocumentUpdateData, docGuid: string) {
        const docData: WizDocument = Object.assign(doc, {
            docGuid,
            spaceGuid: this.spaceGuid,
            groupGuid: this.groupGuid,
            repositoryGuid: this.repositoryGuid,
        });
        store.setDocumentOperate({
            docList: [docData],
            type: DocumentOperateType.Update,
            updateType: doc.action,
        });
    }
    // MARKS: publish和rename单独拆出接口
    // 发布/更新文档
    async publishDocument(
        docGuid: string,
        name: string,
        isCardView?: boolean,
        isFirstPublish?: boolean,
        isViewModified?: boolean,
        wordCount?: number
    ) {
        const options = this.requestOptions;
        const params = {
            name,
            spaceGuid: this.spaceGuid,
            groupGuid: this.groupGuid,
            repositoryGuid: this.repositoryGuid,
            docGuid,
            isCardView: isCardView ? 1 : 0,
            isFirstPublish: isFirstPublish ? 1 : 0,
            isViewModified: isViewModified ? 1 : 0,
            wordCount: wordCount || 0,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/docs/publish?docGuid=${docGuid}`,
                    data: params,
                },
                options
            )
        );
        this.updateDocumentOperate(
            Object.assign(params, {action: DocumentOperateType.Publish}),
            docGuid
        );
        return result;
    }

    // 重命名文档
    async renameDocument(docGuid: string, name: string) {
        const curDocument = store.getCurDocument();
        if (curDocument?.name === name) {
            // 如果重命名后的文档名和现在的文档名一样则不走重命名逻辑
            // 并恢复原本的节点信息
            return new Promise((resolve) => {
                resolve({...curDocument});
            });
        }
        const options = this.requestOptions;
        // 名称为空的时候需要传入默认名称
        const resName = name.trim() || '未命名文档';
        const params = {
            name: resName,
            spaceGuid: this.spaceGuid,
            groupGuid: this.groupGuid,
            repositoryGuid: this.repositoryGuid,
            docGuid,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/docs/rename?docGuid=${docGuid}`,
                    data: params,
                },
                options
            )
        );
        this.updateDocumentOperate(
            Object.assign(params, {
                action: DocumentOperateType.Rename,
                name: result.name,
            }),
            docGuid
        );
        return result;
    }

    // 复制文档
    async updateDocument(docGuid: string, doc: DocumentUpdateData, returnFullResult?: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${this.serverUrl}/docs/${docGuid}`,
                    data: doc,
                },
                {
                    ...options, ...{returnFullResult},
                }
            )
        );
        this.updateDocumentOperate(doc, docGuid);
        return result;
    }

    // 复制文档（支持包含子文档）
    async copyDoc(docGuid: string, type: number, data: {
        [name: string]: any;
        // latest 表示复制最新的内容，默认复制最近的版本内容
        version: string;
        toParentGuid?: string;
        toRepoGuid: string;
        isPathSelect: boolean;
        withChild: boolean;
    }, timeout?: number) {
        const options = this.requestOptions;

        const headers: any = {};
        if (type === DOC_TYPE.DATASHEET || data.withChild) {
            const dataSheetToken = await getDstToken();
            headers['x-datasheet-token'] = dataSheetToken;
        }

        try {
            const result = await this.request(
                Object.assign(
                    {
                        method: 'post',
                        url: `${ServerConfig.ku}/doc/copy?docGuid=${docGuid}`,
                        data: data,
                        headers: headers,
                    },
                    {...options, timeout}
                )
            );
            return result;
        } finally {
            // 复制成功/失败后，都更新目录树
            // 批量复制时，接口失败，也会有部分复制成功的
            this.updateDocumentOperate({action: DocumentOperateType.Copy, ...data}, docGuid);
        }
    }

    // 查询复制文档进度（包含子文档时）
    async getCopyDocProgress(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/progress?docGuid=${docGuid}`,
                },
                options
            )
        );
        // this.updateDocumentOperate({action: 'copy', ...data}, docGuid);
        return result;
    }

    // 复制表格
    async copySheet(docGuid: string, doc: DocumentUpdateData) {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/middleware/${this.repositoryGuid}/docs/${docGuid}/copy`,
                    data: doc,
                    headers: {
                        'x-file-type': 4, // type 1：文档 4：表格
                    },
                },
                options
            )
        );
        this.updateDocumentOperate(doc, docGuid);
        return result;
    }

    // 文档拖拽功能统一使用「复制移动到指定目录下」功能接口
    // async moveUpdateDocument(docGuid: string, doc: DocumentUpdateData) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 method: 'put',
    //                 url: `${this.serverUrl}/docs/${docGuid}`,
    //                 data: doc,
    //             },
    //             {...options, ...{returnFullResult: true}}
    //         )
    //     );
    //     return result;
    // }

    async moveDocument(docGuid: string, doc: DocumentUpdateData) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${this.serverUrl}/docs/${docGuid}`,
                    data: doc,
                },
                {...options, returnFullResult: true}
            )
        );
        return result;
    }

    // MARKS: delete改为单独接口
    async deleteDocument(docGuid: string, withDescendants: boolean = false) {
        const options = this.requestOptions;
        const params = {
            repositoryGuid: this.repositoryGuid,
            docGuid,
            withDescendants: withDescendants,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/docs/delete?docGuid=${docGuid}`,
                    data: params,
                },
                options
            )
        );
        return result;
    }
    // 下载原始文件
    async downloadOriginalFile(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/init/downloadUrl?docGuid=${docGuid}`,
                },
                options
            )
        );
        return result;
    }
    // 导出Excel
    async exportDocument(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/sheet/files/export/v1`,
                    data: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 导出Excel进度获取
    async exportProgressDocument(taskId: string, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/sheet/files/export/progress/v1`,
                    data: {
                        taskId,
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 导出PPT
    async exportPPT(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/ppt/files/${docGuid}/export`,
                },
                options
            )
        );
        return result;
    }

    // 发起会议模式
    async startDocumentMeeting(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.serverUrl}/docs/${docGuid}/meeting/start`,
                },
                options
            )
        );
        return result;
    }

    // 结束会议模式
    async stopDocumentMeeting(docGuid: string, data: DocumentUpdateData) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.serverUrl}/docs/${docGuid}/meeting/stop`,
                    data,
                },
                options
            )
        );
        return result;
    }

    // MARKS: 获取当前知识库在会议模式中的文档列表
    async getDocsInMeeting() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/meeting/docs?repositoryGuid=${this.repositoryGuid}`,
                },
                options
            )
        );
        return result;
    }

    //
    async getDocumentLogs(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.serverUrl}/docs/${docGuid}/logs`,
                },
                options
            )
        );
        return result;
    }

    // ------------------------ xhz ------------------------------
    async GetHistories(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/histories`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    async GetHistory(docGuid: string, version: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/histories/${version}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    async RestoreHistory(docGuid: string, version: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/histories/${version}`,
                    method: 'post',
                },
                options
            )
        );
        return result;
    }

    async DownloadDocumentResources(docGuid: string, resourceName: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/resources/${resourceName}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 获取回收站列表
    getRecycleList(data: {
        pageNum: number;
        pageSize: number;
        // 排序，1：desc 2：asc
        sortType?: 1 | 2;
    }) {
        return this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/recycle/list`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                sortType: 2,
                ...data,
            },
        });
    }

    // 回收站恢复
    async recycleRecovery(docGuids: string[]) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/recycle/recovery`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                docGuids,
            },
        });

        store.setDocumentOperate({
            docList: result,
            type: DocumentOperateType.Recovery,
        });

        return result;
    }

    // 回收站彻底删除
    recycleShred(docGuids: string[]) {
        return this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/recycle/shred`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                docGuids,
            },
        });
    }

    async getRecycleDocumentInfo(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/recycle/docs/${docGuid}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 点赞
    async giveLikes(docGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/like/${docGuid}/create`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                docGuid,
            },
        });
        return result;
    }

    // 取消点赞
    async cancelGiveLikes(docGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/like/${this.repositoryGuid}/${docGuid}/delete`,
            method: 'delete',
        });
        return result;
    }

    // 获取点赞列表
    async getLikesList(docGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/like/${this.repositoryGuid}/${docGuid}/list`,
            method: 'get',
        });
        return result as LikeData[];
    }

    // 新增评论
    async articleComments(data: {
        docGuid: string;
        content: string;
        sourceType?: number; // 1 为新数据，0 或不传为旧数据
        parentGuid?: string;
        rootGuid?: string;
    }) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/comments/${data.docGuid}/create`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                ...data,
            },
        });
        return result;
    }

    // 更新评论
    async updateComments(data: {
        docGuid: string;
        content: string;
        commentGuid: string;
        sourceType?: number; // 1 为新数据，0 或不传为旧数据
    }) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/comments/${data.docGuid}/update`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                ...data,
            },
        });
        return result;
    }

    // 获取评论列表
    async getDocCommentList(data: {
        docGuid: string;
        pageSize: number;
        pageNum: number;
        mentionIds?: string[];
        ascending?: 'asc' | 'desc'; // 不传默认 asc
    }) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/comments/${data.docGuid}/list`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                ...data,
            },
        });
        return result;
    }

    /**
     * 获取底部评论中被 @ 的评论
     */
    async getMentionComment(docGuid: string, userGuid: string, mentionIds: string[]) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/comments/${docGuid}/mention`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                userGuid,
                mentionIds,
            },
        });
        return result;
    }

    // 获取要被置顶的底部评论
    async getCommentTop(docGuid: string, userId: string, commentIds: string[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/comments/${docGuid}/top`,
                    data: {
                        repositoryGuid: this.repositoryGuid,
                        docGuid,
                        userId,
                        commentIds,
                    },
                }
            )
        );
        return result;
    }

    // 删除评论
    async deleteComment(commentGuid: string, docGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/comments/${docGuid}/delete`,
            method: 'post',
            data: {
                repositoryGuid: this.repositoryGuid,
                commentGuid,
            },
        });
        return result;
    }

    async getHavePowerPerson(docGuid: string, params: any = '') {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.serverUrl}/docs/${docGuid}/members${params ? `?memberGuids=${params}` : ''}`,
                },
                options
            )
        );
        return result;
    }

    async getSinglePowerPerson(docGuid: string, params: any = '') {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${this.serverUrl}/docs/${docGuid}/members/${params}`,
                },
                options
            )
        );
        return result;
    }

    async inviteJoin(docGuid?: string, params?: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.serverUrl}/docs/${docGuid}/members`,
                    data: params,
                },
                options
            )
        );
        return result;
    }

    async getTagList(docGuid: string) {
        const repositoryGuid = this.repositoryGuid;
        const options = this.requestOptions;
        const recommend: boolean = this.user.settings?.newSettings?.intelligent?.tagReading || false;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/tag/list?docGuid=${docGuid}&repositoryGuid=${repositoryGuid}&recommend=${recommend}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // MARKS:
    async getRepositoryNum() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/bd/docs/count?repositoryGuid=${this.repositoryGuid}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    async createTag(docGuid: string, tagNames: string[]) {
        const repositoryGuid = this.repositoryGuid;
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/tag/create?docGuid=${docGuid}`,
                    method: 'post',
                    data: {
                        repositoryGuid,
                        names: tagNames,
                    },
                },
                options
            )
        );
        return result;
    }

    async deleteTag(docGuid: string, tagName: string) {
        const repositoryGuid = this.repositoryGuid;
        const options = this.requestOptions;
        const result = await this.request(Object.assign({
            url: `${ServerConfig.ku}/tag/del?docGuid=${docGuid}`,
            method: 'post',
            data: {
                repositoryGuid,
                name: tagName,
            },
        }, options));
        return result;
    }

    async addDocMember(docGuid: string, docMembers: DocMembers, isSingle: boolean = false) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/members`,
                    method: 'post',
                    data: {
                        ...docMembers,
                        isSingle,
                    },
                },
                options
            )
        );
        return result;
    }

    async updatePersonPower(docGuid: string, memberGuid: string | number | undefined, data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${this.serverUrl}/docs/${docGuid}/members/${memberGuid}`,
                    data,
                },
                options
            )
        );
        return result;
    }

    async updateDocMember(docGuid: string, memberGuid: string, docMembers: DocMembers) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/members/${memberGuid}`,
                    method: 'put',
                    data: docMembers,
                },
                options
            )
        );
        return result;
    }

    async deleteMember(docGuid: string, memberGuid: any) {
        assert(memberGuid);
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${this.serverUrl}/docs/${docGuid}/members/${memberGuid}`,
                },
                options
            )
        );
        return result;
    }

    async getDocMembers(docGuid: string, start: number, count: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/members?start=${start}&count=${count}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    async getDocMember(docGuid: string, memberGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/docs/${docGuid}/members/${memberGuid}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 获取用户是否拥有查看文档的权限
    async getUserRole(docGuid: string, userGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/readable?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}&userGuid=${userGuid}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    async getEditorToken(docGuid: string, timeout: number, returnFullError: boolean = false) {
        // 对外场景换了个接口
        if (window.isTocPage) {
            const options = this.requestOptions;
            const result = await this.request(
                Object.assign(
                    {
                        url: `${ServerConfig.ks}/external/repository/doc/getDocRteToken?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
                        method: 'get',
                    },
                    {
                        ...options,
                        timeout,
                        xWikiRteSToken: 'sToken',
                        returnFullError,
                    }
                )
            );
            return result;
        } else {
            const options = this.requestOptions;
            const result = await this.request(
                Object.assign(
                    {
                        url: `${this.serverUrl}/docs/${docGuid}/rteToken`,
                        method: 'get',
                    },
                    {
                        ...options,
                        timeout,
                        xWikiRteSToken: 'sToken',
                        returnFullError,
                    }
                )
            );
            return result;
        }
    }

    // async getEditorTokenOld(docGuid: string, sToken: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${this.serverUrl}/docs/${docGuid}/token`,
    //                 method: 'get',
    //             },
    //             {
    //                 ...options,
    //                 xWikiRteSToken: sToken,
    //             }
    //         )
    //     );
    //     return result;
    // }

    async getTemplateToken(templateId: string, timeout: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${this.serverUrl}/templates/${templateId}/token`,
                    method: 'get',
                },
                {
                    ...options,
                    timeout,
                    xWikiRteSToken: 'sToken',
                }
            )
        );
        return result;
    }
    // async getTemplateTokenOld(templateId: string, sToken: string) {
    //     const options = this.requestOptions;
    //     const result = await this.request(
    //         Object.assign(
    //             {
    //                 url: `${this.serverUrl}/templates/${templateId}/token`,
    //                 method: 'get',
    //             },
    //             {
    //                 ...options,
    //                 xWikiRteSToken: sToken,
    //             }
    //         )
    //     );
    //     return result;
    // }

    async getDocAdmin(docGuid: string, selectRole?: string) {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/member/doc/admins?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
                    method: 'get',
                    params: {
                        applyRole: selectRole,
                    },
                },
                {
                    ...options,
                }
            )
        );
        return result;
    }

    // 机器人共创文档信息接口
    async getCreateTogetherData(
        docGuid: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/virtual/collaboration/list?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
                },
                options
            )
        );
        return result;
    }


    // 机器人读取文档信息接口
    async getReadData(
        docGuid: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/virtual/access/list?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
                },
                options
            )
        );
        return result;
    }

    // 机器人读取按钮点击上报
    async robotBtnReport(data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/virtual/button/report`,
                    data: data,
                },
                options
            )
        );
        return result;
    }

    // MARKS: 获取页面绑定的iCafe卡片列表
    async getICafeCardList(
        docGuid: string,
        params: {pageIndex: number, pageSize: number} = {pageIndex: 1, pageSize: 10}
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/icafe/page?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}&pageIndex=${params.pageIndex}&pageSize=${params.pageSize}`,
                },
                options
            )
        );
        return result;
    }

    // MARKS: 获取页面绑定的会议列表
    async getMeetingsList(
        docGuid: string,
        params: {pageIndex: number, pageSize: number} = {pageIndex: 1, pageSize: 10},
        repositoryGuid: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/meeting/list`,
                    params: {
                        pageId: params.pageIndex,
                        pagesize: params.pageSize,
                        docGuid: docGuid,
                        repositoryGuid: repositoryGuid,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // MARKS: 获取页面绑定的IAPI列表
    async getIApiList(
        docGuid: string,
        repositoryGuid: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/iapi/list`,
                    params: {
                        docGuid: docGuid,
                        repositoryGuid: repositoryGuid,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // MARKS: 获取页面绑定的三方数据列表
    async getThreeParties(
        docGuid: string,
        repositoryGuid: string,
        bizType: string
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/virtual/integration/list`,
                    params: {
                        docGuid: docGuid,
                        repositoryGuid: repositoryGuid,
                        bizType: bizType,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 关联 iCafe 卡片
    async relateICafe(docGuid: string, url: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.serverUrl}/docs/${docGuid}/icafecard/bind`,
                    data: {url},
                },
                options
            )
        );
        return result;
    }

    // 取消关联 iCafe 卡片
    async cancelRelatedICafe(docGuid: string, prefixSequences: string[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${this.serverUrl}/docs/${docGuid}/icafecard/unbind`,
                    data: {prefixSequences},
                },
                options
            )
        );
        return result;
    }

    // 取消展示 IAPI
    async cancelRelatedIAPI(docGuid: string, repositoryGuid: string, apiId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/iapi/unbind?docGuid=${docGuid}`,
                    data: {
                        docGuid,
                        repositoryGuid,
                        apiId: apiId.toString(),
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 划线评论通知知识库的所有者和页面关注者
    async underLineCommentSendMsg(docGuid: string, data: {
        mode: string;
        anchorGuid: string;
        commentGuid: string;
        rootComment: {
            commentGuid: string;
            userGuid: string;
        };
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    // url: `${this.serverUrl}/docs/${docGuid}/anchor/notice`,
                    url: `${ServerConfig.ku}/comments/anchor/notice?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    /**
     * 发布到知识广场状态修改
     * @localURL http://172.21.216.52:8080/square
     * @description 和 彦村 本地联调的地址。
     */
    async updatePublishToKnowledgeSquare(repoId: string, docId: string, publishStatus: IPublishStatus) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/square/publish/${repoId}/${docId}`,
                    method: 'POST',
                    data: {
                        publishStatus,
                    },
                },
                {
                    ...options,
                }
            )
        );
        return result;
    }

    /**
     * 获取发布知识广场的状态
     * @localURL http://172.21.216.52:8080/square
     * @description 和 彦村 本地联调的地址。
     */
    async getPublishToKnowledgeSquare(repoId: string, docId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/square/publish/${repoId}/${docId}`,
                    method: 'get',
                },
                {
                    ...options,
                }
            )
        );
        return result;
    }

    // 获取AIGC白名单
    async getAigcWhites(businessKeys: string[]): Promise<any> {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/uniform/smallFlow/query`,
                    method: 'post',
                    data: {
                        businessKeys,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 同步到个人主页
    async syncToRuLiuHomepageAndSquare(repoGuid: string, docGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/square/publish/sync/userpage`,
            method: 'post',
            params: {
                repoGuid,
                docGuid,
            },
        });
        return result;
    }

    /**
     * 分享到如流，用于块链接分享
     * @param content 分享的链接
     * @param receivers 被分享人，chatType: 1 用户、2 群聊
     */
    async blockLinkShareToRuLiu(content: string, receivers: Array<{chatId: string | number, chatType: 1 | 2}>) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/rl/share/link`,
            method: 'post',
            data: {
                content,
                receivers,
            },
        });
        return result;
    }

    // 保存为历史版本
    async saveAsHistoryVersion(repoGuid: string, docGuid: string, versionName: string) {
        // 对外的接口地址改了
        if (window.isTocPage) {
            const result = await this.request({
                ...this.requestOptions,
                url: `${ServerConfig.ks}/external/repository/docs/saveDocVersion?docGuid=${docGuid}&repositoryGuid=${repoGuid}`,
                method: 'post',
                data: {
                    versionName,
                },
            });
            return result;
        } else {
            const result = await this.request({
                ...this.requestOptions,
                url: `${ServerConfig.ks}/${repoGuid}/docs/${docGuid}/version`,
                method: 'post',
                data: {
                    versionName,
                },
            });
            return result;
        }
    }

    // 历史版本重命名
    async renameHistoryVersion(docGuid: string, versionId: number | string, versionName: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/doc/version/rename`,
            method: 'post',
            data: {
                docGuid,
                versionId,
                versionName,
            },
        });
        return result;
    }

    // 获取表夹一级目录列表
    async getDatasheetList(docGuid: string) {
        const token = store.getData(store.KEYS.DST_TOKEN);
        const result = await this.request({
            ...this.requestOptions,
            method: 'get',
            url: `${ServerConfig.ku}/auth/datasheet/list`,
            params: {
                repositoryGuid: this.repositoryGuid,
                docGuid,
            },
            headers: {
                'x-datasheet-token': token,
            },
        });
        return result;
    }

    // 获取数据表是否继承权限
    async getDatasheetInherit(docGuid: string, nodeId: string) {
        const result = await this.request({
            ...this.requestOptions,
            method: 'get',
            url: `${ServerConfig.ku}/auth/datasheet/inherit/info`,
            params: {
                docGuid,
                nodeId,
            },
        });
        return result;
    }

    // 修改数据表是否继承权限
    async postDatasheetInherit(docGuid: string, nodeId: string, inherit: boolean) {
        const result = await this.request({
            ...this.requestOptions,
            method: 'post',
            url: `${ServerConfig.ku}/auth/datasheet/inherit`,
            data: {
                docGuid,
                nodeId,
                inherit: inherit ? 0 : 1,
            },
        });
        return result;
    }

    // MARKS: 获取星链卡片数据
    async getLinkingGetLike(repositoryGuid?: string, docGuid?: string, entityId?: string) {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/linking/likes?repositoryGuid=${repositoryGuid}&docGuid=${docGuid}`,
                    data: {
                        email: accountServerObj?.user?.email,
                        entityId: entityId,
                    },
                },
                options
            )
        );
        return result;
    }

    // 星链点赞
    async postEntityLinkingLike({entityId, like, isBaikePage}: {
        like: boolean;
        entityId?: string;
        isBaikePage?: boolean;
    }) {
        const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT);
        const options: any = {};

        if (entityId) {
            options.entityId = entityId;
        } else if (isBaikePage) {
            options.baikeOriginalUrl = getDocUrl({
                spaceGuid: this.spaceGuid,
                groupGuid: this.groupGuid,
                repositoryGuid: this.repositoryGuid,
                docGuid,
            });
        }

        return this.request({
            ...this.requestOptions,
            method: 'post',
            url: `${this.serverUrl}/docs/${docGuid}/linking/like`,
            data: {
                email: this.user.email,
                like,
                ...options,
            },
        });
    }

    // MARKS: 获取百科落地页点赞数&点赞状态
    async getBaikeLike() {
        const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT);
        const baikeOriginalUrl = getDocUrl({
            spaceGuid: this.spaceGuid,
            groupGuid: this.groupGuid,
            repositoryGuid: this.repositoryGuid,
            docGuid,
        });

        return this.request({
            ...this.requestOptions,
            method: 'post',
            url: `${ServerConfig.ku}/linking/likes?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
            data: {
                email: this.user.email,
                baikeOriginalUrl,
            },
        });
    }

    // 获取企业百科顶栏tab接口
    async getBaikeTag(rootGuid?: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/baike/tag/index`,
            method: 'post',
            data: {
                rootGuid,
            },
            wikiToken: this.token,
        });
        return result;
    }

    // 获取企业百科词条聚合接口
    async getBaikeTagGather(params: any) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/baike/tag/gather`,
            method: 'post',
            data: params,
            wikiToken: this.token,
        });
        return result;
    }

    // 获取企业百科词条对应文档
    async getBaikeDoc(name: string) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ks}/baike/${name}`,
            method: 'get',
        });
        return result;
    }
    // 获取知识库安全设置
    async getKuSecuritySetting() {
        const options = {
            ...this.requestOptions,
        };
        const repositoryGuid = this.repositoryGuid;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/securityV2/repo/setting`,
                    wikiToken: this.token,
                    params: {
                        repositoryGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 更新知识库安全设置
    async updateKuSecuritySetting(data: IPageSecurityParams) {
        const options = {
            ...this.requestOptions,
        };
        const repositoryGuid = this.repositoryGuid;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/securityV2/repo/setting`,
                    wikiToken: this.token,
                    params: {
                        repositoryGuid,
                    },
                    data,
                },
                options
            )
        );
        return result;
    }
    // 获取知识库页面安全设置
    async getDocSecuritySetting({docGuid}: {docGuid: string}) {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/securityV2/doc/setting`,
                    wikiToken: this.token,
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 更新知识库页面安全设置
    async updateDocSecuritySetting(docGuid: string, data: any) {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/securityV2/doc/setting`,
                    wikiToken: this.token,
                    params: {
                        docGuid,
                    },
                    data,
                },
                options
            )
        );
        return result;
    }
    // 文档安全设置 恢复默认
    async resetDocSecuritySetting(docGuid: string) {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/securityV2/doc/setting/reset`,
                    wikiToken: this.token,
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 安全设置数据导出
    async exportKuSecuritySetting() {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/securityV2/repo/setting/export`,
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }
    // 获取水印设置
    async getWaterMarkCopy(pageSecurityParams: IPageSecurityGetAccessId) {
        const options = {
            ...this.requestOptions,
        };
        const repositoryGuid = pageSecurityParams.repositoryGuid;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    // eslint-disable-next-line max-len
                    url: `${ServerConfig.ku}/security/watermark/${repositoryGuid}`,
                },
                options
            )
        );
        return result;
    }
    // 更新水印设置
    async updateWaterMarkCopy(pageSecurityParams: IPageSecurityGetAccessId, waterMarkParams: IPageSecurityParams) {
        //
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    // eslint-disable-next-line max-len
                    url: `${ServerConfig.ku}/security/watermark/${pageSecurityParams.repositoryGuid}`,
                    data: waterMarkParams,
                },
                options
            )
        );
        return result;
    }

    // 获取禁止复制文档内容设置项
    async getDocForbidCopy(docGuid: string, repositoryGuid: string) {
        const result = await this.request({
            method: 'get',
            url: `${ServerConfig.ku}/securityV2/doc/copy/setting`,
            params: {
                docGuid,
                repositoryGuid,
            },
            ...this.requestOptions,
        });
        return result;
    }

    // 更新禁止复制文档内容设置项
    async postDocForbidCopy(copySetting: 0 | 1, docGuid: string, repositoryGuid: string) {
        const result = await this.request({
            method: 'post',
            url: `${ServerConfig.ku}/securityV2/doc/copy/change`,
            data: {
                docGuid,
                repositoryGuid,
                copySetting,
            },
            ...this.requestOptions,
        });
        return result;
    }

    // 获取文章被引用列表
    async getDocumentReferenceList(
        params: {docGuid: string, userGuid: string, pageNum: number, pageSize: number}
    ) {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/recommend/cite`,
                    params,
                },
                options
            )
        );
        return result;
    }

    // 获取块引用列表
    async getBlockRefList(
        params: {blockId: string, docGuid: string}
    ) {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/recommend/cite`,
                    params,
                },
                options
            )
        );
        return result;
    }

    // 获取文章推荐列表
    async getRecommendReadingList(
        params: {docGuid: string, userGuid: string}
    ) {
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/recommend/doc`,
                    params,
                },
                options
            )
        );
        return result;
    }

    // 如流文档转知识库文档引导接口
    async getGuideDocGuid() {
        const result = await this.request({
            ...this.requestOptions,
            method: 'get',
            url: `${this.serverUrl}/rldocs`,
        });
        return result;
    }
    // MARKS: 分享合并-获取知识库成员列表分页
    async getHavePowerPersonPaging(docGuid: string, params: IpageInfo) {
        const options = Object.assign(this.requestOptions);
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/members/${docGuid}/list`,
                    data: params,
                },
                options
            )
        );
        return result;
    }

    // 转化为知识本
    async convertToKnowledgeBasis(repositoryGuid: string, docGuid: string, inherit?: number, scope?: number) {
        const options = Object.assign(this.requestOptions);
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/book/${repositoryGuid}/${docGuid}/convert`,
                    data: {
                        inherit,
                        scope,
                    },
                },
                options
            )
        );
        return result;
    }

    // 转化为普通文档
    async convertToDoc(repositoryGuid: string, docGuid: string) {
        const options = Object.assign(this.requestOptions);
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/book/${repositoryGuid}/${docGuid}/revert`,
                },
                options
            )
        );
        return result;
    }

    // 常用文档
    // 获取常用文档列表
    async getCommonDocs(repositoryGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            wikiToken: this.token,
            method: 'get',
            url: `${ServerConfig.ku}/active/doc/load`,
            params: {
                repositoryGuid,
            },
        });
        return result;
    }

    // 添加到常用文档列表
    async addToCommonDoc(docGuid: string, repositoryGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            wikiToken: this.token,
            method: 'post',
            url: `${ServerConfig.ku}/active/doc/add`,
            data: {
                docGuid,
                repositoryGuid,
            },
        });
        return result;
    }

    // 移出常用文档列表
    async removeCommonDoc(docGuid: string, repositoryGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            wikiToken: this.token,
            method: 'post',
            url: `${ServerConfig.ku}/active/doc/remove`,
            data: {
                docGuid,
                repositoryGuid,
            },
        });
        return result;
    }

    // 移动常用文档
    async moveCommonDoc(docGuid: string, position: number, repositoryGuid: string) {
        const result = await this.request({
            ...this.requestOptions,
            wikiToken: this.token,
            method: 'post',
            url: `${ServerConfig.ku}/active/doc/move`,
            data: {
                docGuid,
                position,
                repositoryGuid,
            },
        });
        return result;
    }

    // 获取协作目录简介
    async getIntroData(docGuid: string) {
        const options = Object.assign(this.requestOptions);
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/book/${docGuid}/loadIntro`,
                    params: {docGuid},
                },
                options
            )
        );
        return result;
    }

    // 更新协作目录简介
    async updateIntroData(docGuid: string, introduce: string) {
        const options = Object.assign(this.requestOptions);
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/book/${docGuid}/updateIntro`,
                    data: {
                        docGuid,
                        introduce,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取协作目录成员
    async getTeamMembers(repositoryGuid: string, pageSize: number, pageNum: number, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/members/${docGuid}/book/list`,
                    method: 'post',
                    data: {
                        repositoryGuid,
                        pageNum,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取历史版本设置状态
    async getHistoryVersion(docGuid: string) {
        const repositoryGuid = this.repositoryGuid;
        const result = await this.request({
            ...this.requestOptions,
            method: 'get',
            url: `${ServerConfig.ku}/history/setting/${repositoryGuid}/${docGuid}/show`,
        });
        return result;
    }

    // 设置历史版本状态
    async setHistoryVersion(docGuid: string, docHistoryShowStatus: string) {
        const repositoryGuid = this.repositoryGuid;
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/history/setting/${repositoryGuid}/${docGuid}/show`,
                    data: {docHistoryShowStatus},
                },
                options
            )
        );
        return result;
    }

    // 获取@人发送通知开关
    async getMentioningPeople(docGuid: string) {
        const repositoryGuid = this.repositoryGuid;
        const result = await this.request({
            ...this.requestOptions,
            method: 'get',
            url: `${ServerConfig.ku}/mention/setting/${repositoryGuid}/${docGuid}/sheet`,
            wikiToken: this.token,
        });
        return result;
    }

    // 设置@人发送通知开关
    async setMentioningPeople(docGuid: string, sheetMentionStatus: string) {
        const repositoryGuid = this.repositoryGuid;
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/mention/setting/${repositoryGuid}/${docGuid}/sheet`,
                    data: {sheetMentionStatus},
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 获取文档的文档引用设置状态
    async getCite(docGuid: string) {
        const repositoryGuid = this.repositoryGuid;
        const result = await this.request({
            ...this.requestOptions,
            method: 'get',
            url: `${ServerConfig.ku}/recommend/setting/${repositoryGuid}/${docGuid}/cite`,
        });
        return result;
    }

    // 更新文档引用设置开关
    async updateCite(docGuid: string, citeSetting: string) {
        const repositoryGuid = this.repositoryGuid;
        const options = {
            ...this.requestOptions,
        };
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/recommend/setting/${repositoryGuid}/${docGuid}/cite`,
                    data: {citeSetting},
                },
                options
            )
        );
        return result;
    }

    // 获取协作目录
    async getpageDataList(repositoryGuid: string, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/book/${repositoryGuid}/${docGuid}/list`,
                    method: 'post',
                },
                options
            )
        );
        return result;
    }
    // 获取协作目录子节点
    async getBookChildDocs(parentGuid: string) {
        // 对外的接口地址改了
        if (window.isTocPage) {
            const options = this.requestOptions;
            const result = await this.request(
                Object.assign(
                    {
                        method: 'get',
                        url: `${ServerConfig.ks}/external/repository/book/docs?parentGuid=${parentGuid}&repositoryGuid=${this.repositoryGuid}`,
                    },
                    options
                )
            );
            return result;
        } else {
            const options = this.requestOptions;
            const result = await this.request(
                Object.assign(
                    {
                        url: `${this.serverUrl}/book/docs`,
                        method: 'get',
                        params: {parentGuid},
                    },
                    options
                )
            );
            return result;
        }
    }

    // 获取页面管理员，针对百科知识库，已排除库管理员
    async getBaikePageAdmins(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/baike/doc/${docGuid}/admins`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 获取页面所在知识本，针对百科
    async getBookByDoc(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/baike/doc/${docGuid}/bookInfo`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 获取页面编辑权限拥有者，针对百科知识库
    async getBaikePageEditors(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/baike/doc/${docGuid}/editors`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    infoQuery = async ({
        docGuid,
        nodeId,
        needRepositoryData,
    }: {
        docGuid?: string;
        // 数据表nodeId
        nodeId?: string;
        needRepositoryData?: boolean;
    }) => {
        const spaceGuid = this.spaceGuid;
        const groupGuid = this.groupGuid;
        const repositoryGuid = this.repositoryGuid;

        const isTocPage = window.isTocPage;
        const url = isTocPage ? `${ServerConfig.toc}/index/info/query` : `${ServerConfig.ku}/index/info/query`;

        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url,
                    data: {
                        spaceGuid,
                        groupGuid,
                        repositoryGuid,
                        docGuid,
                        nodeId,
                        type: needRepositoryData ? 2 : 1,
                    },
                },
                {
                    ...this.requestOptions,
                    ...accountServerObj.requestOptions,
                    // 需要同时拥有ks 及 as的token
                    mergedRequestType: 'ks',
                }
            )
        );
        return result;
    };

    // 获取知识本用户权限数据
    async getBookDirData(repositoryGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/books/${repositoryGuid}/books`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 获取知识本的公开状态
    async getBookPublicStatus(rootGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/books/scope`,
                    method: 'get',
                    params: {
                        docGuid: rootGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 导入 Excel 文件
     * @param objectKey 存储在 bos 上的文件 key 值
     * @param fileName 文件名
     * @param parentGuid 导入文档父 ID
     */
    async importExcel(objectKey: string, fileName: string, parentGuid: string) {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/sheet/${this.repositoryGuid}/files/import/v1`,
                    method: 'post',
                    data: {
                        objectKey,
                        fileName,
                        parentGuid: parentGuid || '',
                    },
                    timeout: 120 * 1000,
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取导入 Excel 文件进度
     * @param docGuid 转换后在线表格的 id
     * @param taskId 导入任务 ID
     */
    async getImportProgress(docGuid: string, taskId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/sheet/files/${docGuid}/import/progress/v1?taskId=${taskId}`,
                    method: 'post',
                },
                options
            )
        );
        return result;
    }

    /**
     * 导入 Excel 文件（来自客户端）
     * @param file 上传文件信息
     */
    async importExcelFromClient({
        fid,
        chatId,
        uid,
        chatType,
        fileName,
        repositoryGuid,
        parentGuid,
        from,
    }: {
        fid?: string;
        chatId?: string;
        uid?: string;
        chatType?: string;
        fileName?: string;
        repositoryGuid?: string;
        parentGuid?: string;
        from?: number;
    }) {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/sheet/${repositoryGuid || this.repositoryGuid}/files/import/client`,
                    method: 'post',
                    data: {
                        fid,
                        chatId,
                        uid,
                        chatType,
                        fileName,
                        repositoryGuid: repositoryGuid || this.repositoryGuid,
                        parentGuid,
                        from,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取 bos 上传 STS 临时认证票据
     * @param objectKey 存储在 bos 上的文件 key 值
     * @param parentGuid 导入文档父 ID
     */
    async getBosSTSData(objectKey: string, parentGuid?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/ppt/stsData?objectKey=${objectKey}&parentGuid=${parentGuid || ''}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    /**
     * 导入 PPT
     * @param objectKey 存储在 bos 上的文件 key 值
     * @param fileName 文件名
     * @param md5 文件的 md5
     * @param parentGuid 导入文档父 ID
     */
    async importPPT(objectKey: string, fileName: string, md5: string, parentGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/ppt/${this.repositoryGuid}/files/import`,
                    method: 'post',
                    data: {
                        objectKey,
                        fileName,
                        md5,
                        parentGuid: parentGuid || '',
                    },
                },
                options
            )
        );
        return result;
    }

    /**
    * 导入 PPT 文件（来自客户端）
    * @param file 上传文件信息
    */
    async importPPTFromClient({
        fid,
        chatId,
        uid,
        chatType,
        fileName,
        repositoryGuid,
        parentGuid,
        from,
    }: {
        fid?: string;
        chatId?: string;
        uid?: string;
        chatType?: string;
        fileName?: string;
        repositoryGuid?: string;
        parentGuid?: string;
        from?: number;
    }) {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/ppt/client/${repositoryGuid || this.repositoryGuid}/power/import`,
                    method: 'post',
                    data: {
                        fid,
                        chatId,
                        uid,
                        chatType,
                        fileName,
                        repositoryGuid: repositoryGuid || this.repositoryGuid,
                        parentGuid,
                        from,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取导入 PPT 文件进度
     * @param docGuid 转换后在线表格的 id
     */
    async getImportPPTProgress(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/ppt/client/${docGuid}`,
                    method: 'post',
                },
                options
            )
        );
        return result;
    }

    /**
     * 导入 Word 文件
     * @param file 上传文件信息
     * @param parentGuid 导入文档父 ID
     * @param onProgress 导入进度更新
     */
    async importWord(file: any, parentGuid: string, taskId: string, onProgress: (progress: number) => void) {
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('spaceGuid', this.spaceGuid);
        formData.append('groupGuid', this.groupGuid);
        formData.append('repositoryGuid', this.repositoryGuid);
        formData.append('taskId', taskId);

        if (parentGuid) {
            formData.append('parentGuid', parentGuid);
        }

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/docs/word/import`,
                    method: 'post',
                    data: formData,
                    headers: {
                        'content-type': 'multipart/form-data;charset=UTF-8',
                    },
                    timeout: 120 * 1000,
                    onUploadProgress: (progressEvent: any) => {
                        if (progressEvent.lengthComputable) {
                            const {loaded, total} = progressEvent;
                            const progress = ((loaded / total) * 100) || 0;
                            onProgress(progress);
                        }
                    },
                },
                options
            )
        );
        return result;
    }

    /**
    * 导入 Word 文件（来自客户端）
    * @param file 上传文件信息
    */
    async importWordFromClient({
        fid,
        chatId,
        uid,
        chatType,
        fileName,
        repositoryGuid,
        parentGuid,
        from,
        taskId,
    }: {
        fid: string;
        chatId: string;
        uid: string;
        chatType: string;
        fileName: string;
        repositoryGuid?: string;
        parentGuid?: string;
        from?: number;
        taskId: string;
    }) {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/docs/client/word/import`,
                    method: 'post',
                    data: {
                        fid,
                        chatId,
                        uid,
                        chatType,
                        fileName,
                        spaceGuid: this.spaceGuid,
                        groupGuid: this.groupGuid,
                        // repositoryGuid: this.repositoryGuid,
                        repositoryGuid: repositoryGuid || this.repositoryGuid,
                        parentGuid,
                        from,
                        taskId,
                    },
                    timeout: 45 * 1000,
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取导入 Word 文件进度
     * @param docGuid 转换后在线表格的 id
     * @param taskId 导入任务 ID
     */
    async getImportWordProgress(taskId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/docs/word/import/result/${taskId}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取 bos 上传 STS 临时认证票据(与附件上传接口相同，导入 PDF 使用)
     * @param docGuid
     * @param objectKey 存储在 bos 上的文件 key 值
     */
    async getAttachBosSTSData(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.attach}/attachments/ticket`,
                    method: 'get',
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 保存附件信息
     * @param docGuid
     */
    async saveAttachInfo({
        docGuid,
        bucket,
        fileName,
        fileSize,
        object,
    }: {
        docGuid: string;
        bucket: string;
        fileName: string;
        fileSize: number;
        object: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.attach}/attachments/infoSave`,
                    method: 'post',
                    data: {
                        docGuid,
                        bucket,
                        fileName,
                        fileSize,
                        object,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 导入 PDF 文件
     * @param file 上传文件信息
     * @param parentGuid 导入文档父 ID
     */
    async importPDF({
        fileName,
        fileSize,
        parentGuid,
        docGuid,
        fileId,
    }: {
        fileName: string;
        fileSize: number;
        parentGuid: string;
        docGuid: string;
        fileId: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/pdf/files/import`,
                    method: 'post',
                    data: {
                        spaceGuid: this.spaceGuid,
                        groupGuid: this.groupGuid,
                        repositoryGuid: this.repositoryGuid,
                        parentGuid: parentGuid || '',
                        docGuid,
                        fileName,
                        fileSize,
                        fileId,
                        position: +new Date(),
                    },
                },
                options
            )
        );
        return result;
    }

    /**
    * 导入 PDF 文件（来自客户端）
    * @param file 上传文件信息
    */
    async importPDFFromClient({
        fid,
        chatId,
        uid,
        chatType,
        docGuid,
        fileName,
        repositoryGuid,
        parentGuid,
        from,
    }: {
        fid: string;
        chatId: string;
        uid: string;
        chatType: string;
        docGuid: string;
        fileName: string;
        repositoryGuid?: string;
        parentGuid?: string;
        from?: number;
    }) {
        const options = this.requestOptions;

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/pdf/client/files/import`,
                    method: 'post',
                    data: {
                        fid,
                        chatId,
                        uid,
                        chatType,
                        spaceGuid: this.spaceGuid,
                        groupGuid: this.groupGuid,
                        // repositoryGuid: this.repositoryGuid,
                        position: +new Date(),
                        docGuid,
                        fileName,
                        repositoryGuid: repositoryGuid || this.repositoryGuid,
                        parentGuid,
                        from,
                    },
                    timeout: 45 * 1000,
                },
                options
            )
        );
        return result;
    }

    /**
    * 导入 Excel (转换为数据表)
    * @param file 上传文件信息
    * @param parentGuid 导入文档父 ID
    * @param onProgress 导入进度更新
    */
    async importExcelDst(file: any, parentGuid: string, onProgress: (progress: number) => void) {
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('spaceGuid', this.spaceGuid);
        formData.append('groupGuid', this.groupGuid);
        formData.append('repositoryGuid', this.repositoryGuid);
        formData.append('position', (+new Date()).toString());

        if (parentGuid) {
            formData.append('parentGuid', parentGuid);
        }
        const dataSheetToken = await getDstToken();

        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/datasheet/folder/import`,
                    method: 'post',
                    data: formData,
                    headers: {
                        'content-type': 'multipart/form-data;charset=UTF-8',
                        'x-datasheet-token': dataSheetToken,
                    },
                    timeout: 120 * 1000,
                    onUploadProgress: (progressEvent: any) => {
                        if (progressEvent.lengthComputable) {
                            const {loaded, total} = progressEvent;
                            const progress = ((loaded / total) * 100) || 0;
                            onProgress(progress);
                        }
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 分享链接到如流，用于划线评论
     * @param content 分享的链接
     * @param receivers 被分享人，chatType: 1 用户、2 群聊
     */
    async shareLinkToRuLiu(content: string, receivers: Array<{chatId: string | number, chatType: 1 | 2}>) {
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/rl/share/link`,
            method: 'post',
            data: {
                content,
                receivers,
            },
        });
        return result;
    }

    // 知识本权限缩小
    async inheritKnowledge(data: {action: string}, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/book/inherit/${docGuid}`,
                    method: 'post',
                    data,
                },
                options
            )
        );
        return result;
    }

    // 获取知识本信息-简版
    async getBookInheritInfo(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/books/simpleInfo`,
                    method: 'get',
                    params: {docGuid},
                },
                options
            )
        );
        return result;
    }
    // 停服更新配置获取
    async getServiceUpdateConfig() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/service/update/config`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }
    // 下载附件 操作日志记录
    async getDownloadRecord(repositoryGuid: string, docGuid: string, fileGuid: string, fileName: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    // url: `${ServerConfig.ks}/${repositoryGuid}/docs/${docGuid}/attach/download`,
                    url: `${ServerConfig.ku}/docs/attach/download?repositoryGuid=${repositoryGuid}&docGuid=${docGuid}&fileGuid=${fileGuid}&fileName=${fileName}`,
                    method: 'get',
                    // params: {fileGuid, fileName},
                },
                options
            )
        );
        return result;
    }
    // 判断移动时操作者是否为原知识库及移动目的知识库的管理员
    async checkBothAdmin(toRepoGuid: string, docGuid: string, sync: boolean, toParentGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    url: `${ServerConfig.ku}/doc/move/checkBothAdmin`,
                    method: 'post',
                    data: {
                        toRepoGuid,
                        docGuid,
                        sync,
                        toParentGuid,
                    },
                }
            )
        );
        return result;
    }
    // 升级版的移动接口
    async moveDocumentandRight(doc: {
        toParentGuid?: string;
        toRepoGuid: string;
        docGuid: string;
        checkTime: string;
        sync?: boolean;
        isKeepPermission?: boolean;
        isUpper?: boolean | string;
        posDocGuid?: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                options,
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/move`,
                    data: doc,
                }
            )
        );
        return result;
    }
    // 获取划词评论绑定的群聊信息
    getReplyBindGroup(docGuid: string, toast: any, commentGuidList: string[]) {
        const options = this.requestOptions;
        const data = {
            commentGuidList,
        };
        try {
            return this.request(
                Object.assign(
                    {
                        method: 'post',
                        url: `${ServerConfig.ku}/comment/${docGuid}/group/info`,
                        data,
                    },
                    options
                )
            );
        } catch (error: any) {
            error?.msg && toast({type: 'fail', content: error.msg});
            return Promise.resolve('');
        }
    }
    // 获取仅某几个人在群内的群聊列表
    getGroupListByUserIdList(userGuidList: string[], toast: any) {
        const options = this.requestOptions;
        const data = {
            userGuidList,
        };
        try {
            return this.request(
                Object.assign(
                    {
                        method: 'post',
                        url: `${ServerConfig.ku}/rul/group/sameMember`,
                        data,
                        wikiToken: this.token,
                    },
                    options,
                    {
                        returnFullError: true,
                    }
                )
            );
        } catch (error: any) {
            error?.msg && toast({type: 'fail', content: error.msg});
        }
    }
    // 创建群聊并绑定
    createGroup(docGuid: string, action: 'add' | 'reply' | 'modify', commentGuid: string, userGuidList: string[]) {
        const options = this.requestOptions;
        const data = {
            action,
            commentGuid,
            userGuidList,
        };
        return this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/comment/${docGuid}/bind`,
                    data,
                },
                options
            )
        );
    }
    // 绑定群聊
    bindingGroup(docGuid: string, action: 'add' | 'reply' | 'modify', commentGuid: string, group: GroupInfo) {
        const options = this.requestOptions;
        const data = {
            action,
            commentGuid,
            groupId: group.groupId,
            groupName: group.groupName,
        };
        return this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/comment/${docGuid}/bind`,
                    data,
                },
                options
            )
        );
    }
    // 取消划词评论和群的关联
    unbindingGroup(docGuid: string, toast: any, groupId: number, commentGuid: string) {
        const options = this.requestOptions;
        const data = {
            commentGuid,
            groupId,
        };
        try {
            return this.request(
                Object.assign(
                    {
                        method: 'post',
                        url: `${ServerConfig.ku}/comment/${docGuid}/unbind`,
                        data,
                    },
                    options
                )
            );
        } catch (error: any) {
            error?.msg && toast({type: 'fail', content: error.msg});
            return Promise.resolve('');
        }
    }
    // 查询群信息接口
    isUserInGroup(toast: any, groupId: number) {
        const options = this.requestOptions;
        const data = {
            groupId,
        };
        try {
            return this.request(
                Object.assign(
                    {
                        method: 'post',
                        url: `${ServerConfig.ku}/rul/group/info`,
                        data,
                        wikiToken: this.token,
                    },
                    options
                )
            );
        } catch (error: any) {
            error?.msg && toast({type: 'fail', content: error.msg});
            return Promise.resolve('');
        }
    }

    // 查看当前文档所属的已确权部门
    async getDocBelongsDepts(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/members/certainGroup`,
                    method: 'get',
                    params,
                },
                options
            )
        );
        return result;
    }

    // 设置公开时效性
    async setPublicTimeliness(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/close/doc/add`,
                    method: 'post',
                    data: params,
                },
                options
            )
        );
        return result;
    }

    // 重置公开时效性
    async resettingPublicTimeliness(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/close/doc/cancel`,
                    method: 'DELETE',
                    params,
                },
                options
            )
        );
        return result;
    }

    // 获取公开时效性
    async getPublicTimeliness(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/close/doc/left`,
                    method: 'get',
                    params,
                },
                options
            )
        );
        return result;
    }

    // 文档在部门内公开（添加）
    async addDocBelongsInDepts(params: any, data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/members/create`,
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    params,
                    data,
                },
                options
            )
        );
        return result;
    }

    // 文档在部门内公开（修改）
    async changeDocBelongsInDepts(params: any, data: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/members/update`,
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    params,
                    data,
                },
                options
            )
        );
        return result;
    }

    // 文档在部门内公开（删除）
    async deleteDocBelongsInDepts(params: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/members/delete`,
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    params,
                },
                options
            )
        );
        return result;
    }

    // pdf转换word
    async pdfConvertWord(docGuid: string, attachId: string, taskId: string, userGuid?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/attachments/convert`,
                    data: {
                        docGuid,
                        attachId,
                        taskId,
                        userGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 查询pdf转换word进度
    async statusPdfConvertWord(taskId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/attachments/convert/status`,
                    data: {
                        taskId,
                    },
                },
                options
            )
        );
        return result;
    }

    // 查询最近全部浏览记录（不去重）
    async getRecentBrowseRecords(query: {
        docGuid: string | undefined;
        repositoryGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/recent/doc/page`,
                    method: 'get',
                    params: query,
                },
                options
            )
        );
        return result;
    }

    // 查询最近浏览记录（去重）
    async getRecentBrowseRecordsAndFilter(query: {
        docGuid: string | undefined;
        repositoryGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/recent/doc/brief`,
                    method: 'get',
                    params: query,
                },
                options
            )
        );
        return result;
    }

    // 文档被访量(去重)
    async getRecentBrowseRecordsAndUv(query: {
        docGuid: string | undefined;
        repositoryGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/recent/doc/lastSixMonthUv`,
                    method: 'get',
                    params: query,
                },
                options
            )
        );
        return result;
    }

    // 获取提及文档的摘要
    async getDocSummary(docGuid: string, editionId?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/summary/v1/getDocSummary?mentionDocGuid=${docGuid}&editionId=${editionId || ''}`,
                },
                options
            )
        );
        return result;
    }

    // 获取提及文档摘要点赞/踩状态
    async getSummaryLikeStatus(summaryId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/summary/v1/feedback?summaryId=${summaryId}`,
                },
                options
            )
        );
        return result;
    }

    // 更新提及文档摘要点赞/踩状态
    async updateSummaryLikeStatus(type: string, summaryId: string, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/summary/v1/feedback`,
                    data: {
                        type,
                        summaryId,
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    // 送知识币
    async giveCoins(docGuid: string, comment?: string) {
        const data: any = {
            repositoryGuid: this.repositoryGuid,
            docGuid,
        };
        if (comment) {
            data.comment = comment;
        }
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/doc/coin/create`,
            method: 'post',
            data: data,
        });
        return result;
    }

    // 获取当前用户在此文档的夸奖
    async getCoinComment(docGuid: string) {
        const data: any = {
            repositoryGuid: this.repositoryGuid,
            docGuid,
        };
        const result = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/doc/coin/comment`,
            method: 'get',
            params: data,
            wikiToken: this.token,
        });
        return result;
    }

    // 获取文档知识币列表【文档获币列表】
    async giveCoinsList(docGuid: string) {
        const {docCoins} = await this.request({
            ...this.requestOptions,
            url: `${ServerConfig.ku}/doc/coin/list?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
            method: 'get',
        });
        return docCoins as CoinData[];
    }

    // 查询指定文档的用户知识币信息
    async getUserCoinInfo(docGuid:string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/doc/coin/info?repositoryGuid=${this.repositoryGuid}&docGuid=${docGuid}`,
                    method: 'GET',
                },
                {
                    ...options,
                }
            )
        );
        return result;
    }


    // 同步数据表保存状态
    async syncDataSheetSave(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/update/info/docUpdate?docGuid=${docGuid}`,
                },
                options
            )
        );
        return result;
    }

    // 搜索可移入知识库列表（复制移动需求迁移的新接口）
    async searchRepositoriesList(query: {
        docGuid: string | undefined;
        page: number;
        pageSize: number;
        q: string | undefined;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/repositories`,
                    params: query,
                },
                options
            )
        );
        return result;
    }

    // 搜索文档，用于AI模板提取大纲
    async getSearchList(data: {
        page: number;
        pageSize: number;
        q: string;
        rlId: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/ai/broadside/docs/search`,
                    method: 'post',
                    data: {
                        ...data,
                        rl_id: data.rlId,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 复制文档（支持包含子文档）(新)
    async newCopyDoc(docGuid: string, type: number, data: {
        [name: string]: any;
        // latest 表示复制最新的内容，默认复制最近的版本内容
        version: string;
        toParentGuid?: string;
        toRepoGuid: string;
        isPathSelect: boolean;
        withChild: boolean;
    }, timeout?: number) {
        const options = this.requestOptions;

        const headers: any = {};
        if (type === DOC_TYPE.DATASHEET || data.withChild) {
            const dataSheetToken = await getDstToken();
            headers['x-datasheet-token'] = dataSheetToken;
        }

        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/copy?docGuid=${docGuid}`,
                    data: data,
                    headers,
                },
                {...options, timeout}
            )
        );
        return result;
    }

    // 复制移动前的鉴权
    async copyAndMovePermissionVerification(data: {
        toParentGuid?: string;
        toRepoGuid: string;
        docGuid: string;
        type: number;
        withChildren?: boolean;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/preCheck`,
                    data: data,
                },
                options
            )
        );
        return result;
    }

    // 获取最近使用列表
    async getRecentPath() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/recentPath`,
                    // params: data,
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 安全设置-个人动态（只用来修改知识库层）
    async updatePersonalDynamics(user: User) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'put',
                    url: `${ServerConfig.ku}/security/personal/trend`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: {settings: user.settings},
                },
                options
            )
        );
        return result;
    }

    // 下载全部附件
    async getDownloadAttachmentList(docGuid: string, attachIds: any) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/attachments/packDownload`,
                    method: 'post',
                    wikiToken: this.token,
                    data: {
                        docGuid,
                        attachIds,
                    },
                },
                options
            )
        );
        return result;
    }

    // 获取团队知识库首页嵌入数据表和仪表盘链接
    async getTeamKnlBaseHomeEmbedUrl(params: any) {
        // const dataSheetToken = await getDstToken();
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/datasheet/link/repo/homepage/embed`,
                    headers: {
                        // 'x-datasheet-token': dataSheetToken,
                    },
                    params,
                },
                options
            )
        );
        return result;
    }

    // 知识库页面权限导出功能（是否有权限展示）
    async getRepoPagesVisibleInfo() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/download/repo/visible`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    // 知识库页面权限导出功能（点击下载）
    async exportRepoAuthorityPages() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/download/repo/auth?repositoryGuid=${this.repositoryGuid}`,
                    method: 'get',
                },
                options
            )
        );
        return result;
    }

    /**
     * 文档内创建数据表块
     * @param docGuid
     * @param type 视图类型
     * @param name 视图名称
     * @param chartType 图表类型(新建图表时需要)
     */
    async createDataSheetBlock(docGuid: string, type: string, name: string, chartType?: string) {
        const dataSheetToken = await getDstToken();
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/datasheet/block/create`,
                    headers: {
                        'x-datasheet-token': dataSheetToken,
                    },
                    data: {
                        docGuid,
                        type,
                        name,
                        chartType,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
    * 文档内复制数据表块
    * @param targetDocId 目标文档id
    * @param editUrl 视图编辑链接
    */
    async copyDataSheetBlock(targetDocId: string, editUrl: string) {
        const dataSheetToken = await getDstToken();
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/datasheet/internal/block/urls`,
                    headers: {
                        'x-datasheet-token': dataSheetToken,
                    },
                    data: {
                        targetDocId,
                        params: [{editUrl}],
                        mode: 2,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
    * 获取图表数据
    * @param docGuid
    * @param datasheetId 数据表id
    * @param viewId 视图id
    */
    async getChartData(docGuid: string, datasheetId: string, viewId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/datasheet/block/records`,
                    data: {
                        docGuid,
                        datasheetId,
                        viewId,
                    },
                },
                options
            )
        );
        return result;
    }

    // 开启关闭问答能力
    async settingQuestionAnswer({
        repoGuid,
        chatRepo,
    }: {
        chatRepo: string;
        repoGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    // url: `${ServerConfig.ku}/chat/repo/${repoGuid}/setting`,
                    url: `${this.mockBaseUrl}/wiki/ku/chat/repo/${repoGuid}/setting`,
                    data: {
                        chatRepo, // 1:开启 2: 关闭
                    },
                },
                options
            )
        );
        return result;
    }
    // 查询当前知识库是否支持发起提问
    async questionAnswerIsOpen(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    // url: `${ServerConfig.ku}/chat/repo/support/${repoGuid}`,
                    url: `${this.mockBaseUrl}/wiki/ku/chat/repo/support/${repoGuid}`,
                },
                options
            )
        );
        return result;
    }
    // 获取问答推荐列表
    async getQuestionAnswerRecommendList(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    // url: `${ServerConfig.ku}/chat/repo/{repoGuid}/questions`,
                    url: `${this.mockBaseUrl}/wiki/ku/chat/repo/${repoGuid}/questions`,
                },
                options
            )
        );
        return result;
    }
    // 问答发起提问
    async sendQuestion({
        query,
        repoGuid,
    }: {
        query: string;
        repoGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    // url: `${ServerConfig.wiki}/chat/repo/{repoGuid}/questions`,
                    url: `${this.mockBaseUrl}/wiki/ai/chat/repo/${repoGuid}`,
                    data: {
                        query,
                    },
                },
                options
            )
        );
        return result;
    }

    // 保存问答
    async saveQuestionAnswer({
        repoGuid,
        ...data
    }: {
        question: string;
        repoGuid: string;
        blockId: string;
        id: string;
        answer: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    // url: `${ServerConfig.ku}/chat/repo/${repoGuid}/record`,
                    url: `${this.mockBaseUrl}/wiki/ku/chat/repo/${repoGuid}/record`,
                    data,
                },
                options
            )
        );
        return result;
    }

    // 查询问答历史记录
    async getQuestionAnswerHistory(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    // url: `${ServerConfig.ku}/chat/repo/${repoGuid}/records`,
                    url: `${this.mockBaseUrl}/wiki/ku/chat/repo/${repoGuid}/records`,
                },
                options
            )
        );
        return result;
    }

    // 查询问答初始化进度
    async getQuestionAnswerRefresh(repoGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    // url: `${ServerConfig.ku}/chat/repo/${repoGuid}/refresh`,
                    url: `${this.mockBaseUrl}/wiki/ku/chat/repo/${repoGuid}/refresh`,
                },
                options
            )
        );
        return result;
    }

    // 库问答详情导出
    async exportQuestionAnswerData() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/chat/repo/export`,
                    method: 'get',
                    params: {
                        repositoryGuid: this.repositoryGuid,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 查询哭问答使用情况
    async getQuestionAnswerData() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    url: `${ServerConfig.ku}/chat/repo/data`,
                    method: 'get',
                    params: {
                        repositoryGuid: this.repositoryGuid,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 查询某个用户的操作日志，不传userGuid时查询所有
    // eslint-disable-next-line max-params
    async getRepositoryUserLogs(
        spaceGuid: string,
        groupGuid: string,
        repositoryGuid: string,
        pageSize: number,
        pageNum: number,
        ascending: 'desc' | 'asc',
        userGuid?: string
    ) {
        //
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(groupGuid, 'groupGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');

        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/logs`,
                    params: {
                        spaceGuid,
                        repositoryGuid,
                        userGuid,
                        ascending,
                        pageNum,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取全量文档内容
     *
     * @param docGuid
     * @returns 返回获取到的文档内容
     */
    async getDocContent(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/ai/broadside/${docGuid}/doc/detail`,
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 查询操作日志的所有用户列表
    async getRepositorySettingLogUsers(
        spaceGuid: string,
        repositoryGuid: string,
        pageSize: number,
        pageNum: number
    ) {
        assert(spaceGuid, 'spaceGuid can not be null');
        assert(repositoryGuid, 'repositoryGuid can not be null');
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/repository/log/members`,
                    params: {
                        spaceGuid,
                        repositoryGuid,
                        pageNum,
                        pageSize,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 发起推荐文档（空文档大纲）
     *
     * @param docGuid
     * @param title 文档标题
     * @param label 选择标签
     * @param query 输入内容，剔除 prompt
     * @returns 推荐结果
     */
    async recommendDoc(docGuid: string, title: string, label: string, query: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/ai/broadside/${docGuid}/doc/recommend`,
                    data: {
                        title,
                        label,
                        query,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取卡片视图信息（兼容线上老数据）
     *
     * @param docGuid 文档 ID
     * @returns 返回请求的响应结果
     */
    async getCardViewInfo(docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/lightDemonstration/docSetting`,
                    params: {
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
      * 存储用户切换视图 & 主题行为信息（将会决定用户新建文档时默认的视图和主题）
      *
      * @param param0 参数对象，包含以下属性：
      *  - cardView: 卡片视图字符串，可选
      *  - theme: 主题，可选
      *  - showSlideCover: 是否展示封面，可选
      * @returns 返回请求结果
      */
    async setCardViewInfo({cardView, theme, showSlideCover}: {cardView?: string, theme?: string, showSlideCover?:string }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/card/mode/user/cardSetting`,
                    data: {
                        cardView,
                        theme,
                        showSlideCover,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 打开盲盒
     *
     * @param boxGuid 盲盒 Guid
     * @returns 返回盲盒打开结果
     */
    async openBox(boxGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/blindBox/open`,
                    data: {
                        boxGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 知识库展示具体人数
    async getPurviewMemberCount({
        needRepoMember = false,
        ...resData
    }: {
        repoGuid: string;
        needRepoMember?: boolean;
        docGuid?: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/auth/repo/member/count`,
                    data: {
                        needRepoMember,
                        ...resData,
                    },
                },
                options
            )
        );
        // needRepoMember 传false也会返回repoMemberCount为"",但是不要直接覆盖了之前拿到的repoMemberCount
        if (!needRepoMember) {
            delete result.repoMemberCount;
            delete result.repoCounting;
        }
        return result;
    }
    async giveCoinShareDoc(
        repositoryGuid: string,
        docGuid: string,
        shareMembers: Array<{avatar: string, gid: string, name: string}>
    ) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/coin/shares`,
                    data: {
                        repositoryGuid,
                        docGuid,
                        shareMembers,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取官方素材
     * @param tagList 筛选标签
     * @param type 最新最热筛选
     * @returns 返回获取到的素材内容
     */
    async getOfficialMaterial(tagList: string[] = [], type: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/matter/findOfficialByTag`,
                    data: {
                        tagList,
                        type,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取当前用户素材
     *
     * @returns 返回获取到的素材内容
     */
    async getCurUserMaterial() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/matter`,
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取官方模板红点状态
     *
     */
    async getMatterNew() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/matter/new`,
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 应用模板时记录，生成最近使用数据
     *
     */
    async matterApply({
        docGuid,
        matterGuid,
    }: {
        docGuid: string;
        matterGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/matter/apply`,
                    data: {
                        docGuid,
                        matterGuid,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取最近使用素材
     *
     * @returns 返回获取到的素材内容
     */
    async getLatelyMaterial() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/matter/recent`,
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 保存素材
     *
     * @returns 返回素材内容
     */
    async addMaterial({
        docGuid,
        nodeMessageList,
        content,
    }: {
        docGuid: string;
        nodeMessageList: Array<{type: string, path: number[]}>;
        content: any[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/matter`,
                    data: {
                        docGuid,
                        nodeMessageList,
                        content,
                    },
                },
                options
            )
        );
        return result;
    }

    /**
     * 置顶/取消置顶素材
     * @param matterId 素材 id
     * @param isTop 当前是否置顶
     */
    async topMaterial(matterId: string, isTop: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/matter/top`,
                    data: {
                        matterId,
                        type: isTop ? 0 : 1,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 删除素材
     * @param matterId 素材 id
     */
    async deleteMaterial(matterId: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${ServerConfig.ku}/matter`,
                    params: {
                        matterId,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 更新模板信息
     *
     * @param id 模板 ID
     * @param tags 所属标签
     * @param category 所属纵向分类
     * @param url 模板占位图
     * @param name 模板名称
     * @returns 返回更新结果
     */
    async updateMaterial({id, tags, category, url, name}: {
        id: string;
        tags: string[];
        category: string;
        url: string;
        name: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/matter/tag`,
                    data: {
                        matterGuid: id,
                        typeName: category,
                        url,
                        tagList: tags,
                        name,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取模板库配置信息
     * @returns 标签&分类配置信息
     */
    async getMaterialConfigData() {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/matter/tagList`,
                },
                options
            )
        );
        return result;
    }

    /**
     * 上传模板占位图片
     *
     * @param matterGuid 模板 ID
     * @param file 文件对象
     * @returns 上传结果
     */
    async uploadMaterialImage(matterGuid: string, file: any) {
        const options = this.requestOptions;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('matterGuid', matterGuid);

        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.attach}/template/coverUpload`,
                    data: formData,
                    headers: {
                        'content-type': 'multipart/form-data;charset=UTF-8',
                    },
                    timeout: 30 * 1000,
                },
                options
            )
        );
        return result;
    }

    /**
     * 获取模板所属标签
     *
     * @param matterGuid 模板 ID
     * @returns 所属标签
     */
    async getMaterialBelongTags(matterGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/matter/matterTags`,
                    params: {
                        matterGuid,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }
    // 获取文档内某个卡片的点赞信息
    async getCurCardLikeUserInfo({
        repositoryGuid,
        docGuid,
        blockId,
        pageSize,
        pageNum,
        created,
    }: {
        repositoryGuid: string;
        docGuid: string;
        blockId: string;
        pageSize: number;
        pageNum: number;
        created: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/like/${repositoryGuid}/${docGuid}/list/${blockId}`,
                    params: {
                        pageNum,
                        pageSize,
                        created,
                    },
                },
                options
            )
        );
        return result;
    }
    // 文档内卡片取消点赞
    async cancelDocCardLike({
        repositoryGuid,
        docGuid,
        blockId,
    }: {
        repositoryGuid: string;
        docGuid: string;
        blockId: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'delete',
                    url: `${ServerConfig.ku}/like/${repositoryGuid}/${docGuid}/delete`,
                    params: {
                        blockId,
                    },
                },
                options
            )
        );
        return result;
    }
    // 文档内卡片进行点赞
    async giveDocCardLike({
        repositoryGuid,
        docGuid,
        blockId,
    }: {
        repositoryGuid: string;
        docGuid: string;
        blockId: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/like/${docGuid}/create`,
                    data: {
                        blockId,
                        repositoryGuid,
                        docGuid,
                    },
                },
                options
            )
        );
        return result;
    }
    // 卡片变更通知
    async cardChange({
        action,
        docGuid,
        blockId,
        toBlockId,
    }: {
        action: number;
        docGuid: string;
        blockId: string;
        toBlockId: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/card/mode/block/change`,
                    data: {
                        blockId,
                        action,
                        docGuid,
                        toBlockId,
                    },
                },
                options
            )
        );
        return result;
    }
    // 获取文档内所有卡片的点赞数量
    async getDocAllCardLikeNumInfo({
        docGuid,
        repositoryGuid,
    }: {
        docGuid: string;
        repositoryGuid: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/like/${repositoryGuid}/${docGuid}/block`,
                },
                options
            )
        );
        return result;
    }

    // 查询最近协作过的群组列表
    async getRecommendGroup(repoGuid: string, count?: number, docGuid?: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/recent/group/cooperate`,
                    data: {
                        repoGuid,
                        count,
                        docGuid,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 查询3人以上的匹配群组
    async getGroupMatch(userIdList: string[], repositoryGuid: string, docGuid: string) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/open/group/match`,
                    data: {
                        userIdList: userIdList,
                        repoGuid: repositoryGuid,
                        docGuid: docGuid,
                    },
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 获取与我相关的信息
    async getAboutmeInfo(docGuid: string, infoType: string, showAi: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/related2meInfo?docGuid=${docGuid}${infoType}&showAi=${showAi}`,
                    wikiToken: this.token,
                },
                options
            )
        );
        return result;
    }

    // 目录树批量操作-获取选中文档列表
    async getTreeSelectAllList({
        repositoryGuid,
        parentDocGuids,
        singleDocGuids,
    }: {
        repositoryGuid: string;
        parentDocGuids: string[];
        singleDocGuids: string[];
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/directory/select/tree`,
                    data: {
                        repositoryGuid,
                        parentDocGuids,
                        singleDocGuids,
                    },
                },
                options
            )
        );
        return result;
    }

    // 目录树批量操作-批量授权
    async impowerAll({
        repositoryGuid,
        docGuids,
        members,
        roleName,
    }: {
        repositoryGuid: string;
        docGuids: string[];
        members: any[];
        roleName: string;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/directory/auth/docs`,
                    data: {
                        repositoryGuid,
                        docGuids,
                        members,
                        roleName,
                    },
                },
                {...options, timeout: 10 * 1000, returnFullResult: true}
            )
        );
        return result;
    }

    // 目录树批量操作-获取文档子节点数量
    async getTreeChildCount({
        repositoryGuid,
        parentGuid,
        capacity,
    }: {
        repositoryGuid: string;
        parentGuid: string;
        capacity: number;
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/directory/child/count`,
                    params: {
                        repositoryGuid,
                        parentGuid,
                        capacity,
                    },
                },
                options
            )
        );
        return result;
    }

    // 快速移动到顶部/底部
    async quickMoveToTopOrBottom(docGuid: string, goTop: boolean) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/doc/quick/move`,
                    data: {
                        docGuid,
                        goTop,
                    },
                },
                options
            )
        );
        return result;
    }
    // 目录树批量操作-批量复制到/移动到
    async getBatchCopyMoveTo({
        repositoryGuid,
        singleDocGuids,
        parentDocGuids,
        action,
    }: {
        repositoryGuid: string;
        parentDocGuids: string[];
        singleDocGuids: string[];
        action: 'copy' | 'move';
    }) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/directory/perm/list`,
                    data: {
                        repositoryGuid,
                        parentDocGuids,
                        singleDocGuids,
                        action,
                    },
                },
                options
            )
        );
        return result;
    }

    // 目录树批量操作-批量复制到/移动到
    async batchCopyMoveTo(params: {
        repositoryGuid: string;
        docGuids: string[];
        toRepoGuid: string;
        toParentGuid: string;
        action: string;
    }, timeout: number) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/directory/batch/operate`,
                    data: params,
                },
                {...options, timeout}
            )
        );
        return result;
    }

    // 获取当前评论的关注者列表
    async getCommentListFocus(repositoryGuid: string, docGuid: string, participantIds: any[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/comments/${repositoryGuid}/${docGuid}/members/status`,
                    wikiToken: this.token,
                    data: {
                        participantIds,
                    },
                },
                options
            )
        );
        return result;
    }

    // 通过userguid判断是否离职
    async getUserResign(userGuids: string[]) {
        const options = this.requestOptions;
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/internal/v1/user/usersResign`,
                    wikiToken: this.token,
                    data: {
                        userGuids,
                    },
                },
                options
            )
        );
        return result;
    }

}

export default KnowledgeServer;
